import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

// Components
import LiteForm from './partials/LiteForm';
import FullForm from './partials/FullForm';

export default function FeedbackForm(props) {
  const { className } = props;

  const isOwnCity = useSelector(state => state.city.userCity.is_own);

  return isOwnCity || isOwnCity === undefined ? (
    <LiteForm className={className} />
  ) : (
    <FullForm className={className} />
  );
}

FeedbackForm.defaultProps = {
  className: '',
};

FeedbackForm.propTypes = {
  className: PropTypes.string,
};
